module.exports = __webpack_public_path__ + "static/battle_05-e128ce437ef4eb0adab7a2c063183170.jpg";